// Fila de la consulta que el SERVIDOR precargó desde la cita de la Sala (Sala CRM↔HCE 5b, PLAN C9). Se muestra BLOQUEADA en las tres variantes de
// la pestaña Cobro (base, demo, sugerencia): sin cantidad editable ni botón de quitar. El servidor también la rechaza si llega alterada (PUT
// /lineas responde 409), así que este bloqueo es solo la cara visible de una regla que no depende de la pantalla.
import type { JSX } from 'react';
import { Lock } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import type { LineaAtencionCobro } from '@/lib/cobro';

function formatoUsd(cents: number): string {
  return (cents / 100).toLocaleString('es-EC', { style: 'currency', currency: 'USD' });
}

export function LineaConsultaBloqueada({ linea }: { linea: LineaAtencionCobro }): JSX.Element {
  const { t } = useTranslation();
  return (
    <div data-testid="linea-consulta-bloqueada" className="flex items-center justify-between gap-3 rounded-lg border border-border bg-hce-paper px-3 py-2.5 text-sm">
      <span className="min-w-0 flex-1">
        <span className="block text-hce-ink">{linea.description}</span>
        <span className="block text-xs text-hce-muted">
          {formatoUsd(linea.unitAmountCents)} · {t('cobroPaciente.consultaDeCita')}
        </span>
        <span className="block text-xs text-hce-muted">{t('cobroPaciente.consultaBloqueadaAyuda')}</span>
      </span>
      <span className="flex shrink-0 items-center gap-1 text-xs font-medium text-hce-muted">
        <Lock className="size-4" aria-hidden="true" />
        {t('cobroPaciente.consultaBloqueada')}
      </span>
    </div>
  );
}
